import {MapDrawingController, MapLayersController} from '../openstreetmap.controller';
import {RegionManagerService} from '../managers/region-manager.service';

export interface OsmMapKeyboardHost {
  drawingController: MapDrawingController | undefined;
}

export function setupOsmMapKeyboardHandlers(host: OsmMapKeyboardHost): void {
  document.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      if (host.drawingController?.isPolylineDrawingActive()) {
        event.preventDefault();
        host.drawingController.disablePolylineDrawing();
      }
      if (host.drawingController?.isRectangleDrawingActive()) {
        event.preventDefault();
        host.drawingController.disableRectangleDrawing();
      }
    }

    if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
      if (host.drawingController?.isPolylineDrawingActive()) {
        event.preventDefault();
      }
    }
  });
}

export interface OsmMapRegionLabelsHost {
  isMapInitialized: boolean;
  mapInstance: any;
  layersController: MapLayersController | undefined;
  regionManager: RegionManagerService;
}

export function updateOsmRegionLabelsOnZoom(host: OsmMapRegionLabelsHost): void {
  if (!host.isMapInitialized || !host.layersController) {
    return;
  }

  const currentZoom = host.mapInstance.getZoom();
  const allPolygons = host.layersController.getAllPolygons();

  allPolygons.forEach((polygonData: any) => {
    if (polygonData.properties?.type === 'region' && polygonData.properties?.data?.region) {
      if (polygonData.labelElement) {
        const fontSize = host.regionManager.calculateFontSizeByZoom(currentZoom);
        polygonData.labelElement.style.fontSize = `${fontSize}px`;
      }
    }
  });
}
